import APIUtils from '@spothero/utils/api';
import ErrorUtils from 'utils/error-utils';

const transformJobs = ({departments}) => {
    const filteredDepartments = departments
        // Reference: https://github.com/spothero/SpotHero-Django/blob/b79155baf6caec31633768cacf0727700f6c19ee/spothero/static/main/js/modules/common/pages/jobs.js#L38
        // remove the "general" department as it's only used for linking to the application form
        .filter(({id}) => id !== 12475)
        .filter(({jobs}) => jobs.length);

    return filteredDepartments.reduce((acc, department) => {
        department.jobs.forEach(
            ({id, title, updated_at: updatedDate, location}) => {
                acc.push({
                    id,
                    title,
                    departmentName: department.name,
                    locationName: location.name,
                    updatedDate,
                });
            }
        );

        return acc;
    }, []);
};

const cleanJobDetailHtml = content => {
    return content
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/\s*&amp;nbsp;\s*/g, '&nbsp;')
        .replace(/style=&quot;([\w-:\s]*);&quot;/g, '')
        .replace(/&quot;/g, '"')
        .replace(/<p>\s*&nbsp;\s*<\/p>/g, '')
        .replace(/<p>\s*<span\s*>&nbsp;\s*<\/span>\s*<\/p>/g, '')
        .replace(/<br>/g, '');
};

const JobsAPI = {
    async getJobs() {
        try {
            const response = await APIUtils.get(
                'https://api.greenhouse.io/v1/boards/spothero/embed/departments'
            );

            return transformJobs(response.data);
        } catch (error) {
            ErrorUtils.sendSentryError(error);

            return null;
        }
    },
    async getJobById(jobId) {
        try {
            const response = await APIUtils.get(
                `https://api.greenhouse.io/v1/boards/spothero/embed/job?id=${jobId}`
            );

            const {
                title,
                updated_at: updatedDate,
                departments,
                offices,
                content,
            } = response.data;

            return {
                jobId,
                title,
                updatedDate,
                departments: departments.map(({name}) => name),
                locations: offices.map(({name, location}) => ({
                    name,
                    location,
                })),
                content: cleanJobDetailHtml(content),
            };
        } catch (error) {
            ErrorUtils.sendSentryError(error);
            const {status} = error;

            if (status === 404) {
                // eslint-disable-next-line no-throw-literal
                throw {
                    status: 404,
                    showMessage: true,
                    message: `Looks like the job you're searching is no longer available.`,
                };
            }

            throw error;
        }
    },
};

export default JobsAPI;
